import { Heart, CircleX } from 'lucide-react'
import { useRef, useEffect, useState } from 'react'
import { cn } from '../lib/utils'
import type { EventInterestStatus } from '../hooks/useUserEventInterests'
import { GoingCheckIcon } from './GoingCheckIcon'

interface Props {
  status: EventInterestStatus
  className?: string
}

export function EventInterestIcon({ status, className }: Props) {
  const prevStatus = useRef(status)
  const [popKey, setPopKey] = useState(0)

  useEffect(() => {
    if (prevStatus.current !== status) {
      prevStatus.current = status
      setPopKey(k => k + 1)
    }
  }, [status])

  const icon = status === 'going' ? (
    <GoingCheckIcon className={className} />
  ) : status === 'not_going' ? (
    // A muted x-circle — the "no" to Going's check-circle — so a declined
    // event reads as already answered, not as one the user hasn't seen.
    <CircleX className={cn('text-muted-foreground', className)} />
  ) : (
    <Heart className={cn(status === 'interested' && 'fill-interested text-interested', className)} />
  )

  return (
    <span key={popKey} className={cn('inline-flex', popKey > 0 && 'animate-interest-pop')}>
      {icon}
    </span>
  )
}
